import { useMemo } from 'react';
import { QuickFillHooks } from '@frontend/api-quick-fill';
import { useTranslation } from '@frontend/i18n';
import { useSchedulingLocationInfo } from '@frontend/schedule';
import { createNavItem, createSubNavItems } from '../nav-item-utils';

export const useScheduleNavItem = () => {
  const { t } = useTranslation('primaryNav');
  const { getCFLocationMap } = useSchedulingLocationInfo();
  const { hasQuickFillFeature } = QuickFillHooks.useQuickFillFeatureDetails();

  const onlineSchedulingCFLocationMap = getCFLocationMap('onlinescheduling');
  const isOnlineSchedulingEnabledForAnyLocation = Object.values(onlineSchedulingCFLocationMap).some((value) => !!value);

  const subNavItems = useMemo(
    () =>
      createSubNavItems([
        {
          label: t('Calendar'),
          relativePath: '/calendar',
          trackingId: 'nav-schedule-calendar',
          description:
            'Visual scheduling interface for appointments, out of office events, and other time-based events. Offers day view only by provider.',
        },
        {
          label: t('Request History'),
          relativePath: '/request-history',
          show: isOnlineSchedulingEnabledForAnyLocation,
          trackingId: 'nav-schedule-request-history',
          description:
            'Displays historical appointment requests and their statuses. Useful for follow-up and tracking patient inquiries.',
        },
        {
          show: hasQuickFillFeature,
          label: t('Quick Fill History'),
          relativePath: '/quickfill-history',
          trackingId: 'nav-schedule-quickfill-history',
          description:
            'Records the activity and notifications related to filling canceled appointment slots with new patients quickly.',
        },
      ]),
    [t, isOnlineSchedulingEnabledForAnyLocation, hasQuickFillFeature]
  );

  return useMemo(
    () =>
      createNavItem('schedule', {
        iconName: 'calendar',
        label: t('Schedule'),
        root: '/schedule',
        subNavItems,
        settings: { path: '/schedule', label: '' },
      }),
    [t, subNavItems]
  );
};
